const isPositiveInteger = (value) => (Array.isArray(value) ? false : Number.isSafeInteger(value) && value > 0);

export default isPositiveInteger;
